const indexItems = [
  {
    title: '热血战斗漫画全集',
    desc: '鬼灭之刃、咒术回战、进击的巨人等经典战斗漫画大全',
    icon: 'ri-sword-line',
    color: 'bg-primary-100 text-primary-600',
    count: '680部',
  },
  {
    title: '恋爱校园漫画全集',
    desc: '甜蜜校园恋爱日漫韩漫全集，从初恋到修成正果',
    icon: 'ri-heart-line',
    color: 'bg-accent-100 text-accent-600',
    count: '520部',
  },
  {
    title: '奇幻冒险漫画全集',
    desc: '异世界转生、魔法冒险等奇幻题材完结漫画大全',
    icon: 'ri-compass-3-line',
    color: 'bg-secondary-100 text-secondary-600',
    count: '430部',
  },
  {
    title: '悬疑推理漫画全集',
    desc: '烧脑推理和悬疑惊悚完结漫画，下拉式全集一次看透',
    icon: 'ri-search-eye-line',
    color: 'bg-primary-100 text-primary-600',
    count: '280部',
  },
  {
    title: '搞笑日常漫画全集',
    desc: '轻松搞笑的日常系完结漫画，治愈你的不开心',
    icon: 'ri-emotion-laugh-line',
    color: 'bg-accent-100 text-accent-600',
    count: '390部',
  },
  {
    title: '都市职场漫画全集',
    desc: '职场奋斗和都市情感完结漫画，真实又动人',
    icon: 'ri-building-line',
    color: 'bg-secondary-100 text-secondary-600',
    count: '210部',
  },
  {
    title: '治愈温情漫画全集',
    desc: '温暖人心的治愈系完结漫画，适合安静阅读的漫画大全',
    icon: 'ri-cup-line',
    color: 'bg-primary-100 text-primary-600',
    count: '340部',
  },
  {
    title: '科幻未来漫画全集',
    desc: '未来科技和科幻题材完结漫画，脑洞大开的漫画全集',
    icon: 'ri-rocket-line',
    color: 'bg-accent-100 text-accent-600',
    count: '180部',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-4">
          专题合集
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-xl mx-auto">
          按类型浏览完结漫画全集，快速找到你喜欢的漫画题材
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className="group flex flex-col items-center text-center bg-background-50 rounded-xl border border-background-200 p-6 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <span className={`w-12 h-12 flex items-center justify-center rounded-xl ${item.color} mb-4 group-hover:scale-110 transition-transform`}>
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="text-sm font-medium text-foreground-800 mb-1 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 mb-3 leading-relaxed">{item.desc}</p>
              <span className="text-xs text-foreground-400 bg-background-100 px-3 py-1 rounded-full">
                {item.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}